import { render, staticRenderFns } from "./CoinNetworkNewsModal.vue?vue&type=template&id=acab7598&scoped=true&"
import script from "./CoinNetworkNewsModal.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkNewsModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkNewsModal.vue?vue&type=style&index=0&id=acab7598&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acab7598",
  null
  
)

export default component.exports